var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_2747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9927C10.3432 14.9927 9 16.3358 9 17.9927V23.9927H15V17.9927C15 16.3358 13.6568 14.9927 12 14.9927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.9926V23.9926H21C22.6568 23.9926 24 22.6495 24 20.9926V11.8716C24.0002 11.3521 23.7983 10.8529 23.437 10.4796L14.939 1.29261C13.4396 -0.329735 10.9089 -0.429344 9.28655 1.07009C9.20949 1.14134 9.13523 1.21555 9.06403 1.29261L0.581016 10.4766C0.208734 10.8515 -0.000140554 11.3584 7.09607e-08 11.8866V20.9926C7.09607e-08 22.6495 1.34316 23.9926 3 23.9926H6.99998V17.9926C7.01869 15.2658 9.22027 13.0391 11.8784 12.9749C14.6255 12.9087 16.9791 15.1733 17 17.9926Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9927C10.3432 14.9927 9 16.3358 9 17.9927V23.9927H15V17.9927C15 16.3358 13.6568 14.9927 12 14.9927Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_2747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/home_selected.c9dfd0cc5dae27924b35e88f949b81de.svg";
export { ForwardRef as ReactComponent };